
const RUNTIME_CONFIG_PATH =
  "/runtime-config.json";

const VALID_ENVIRONMENTS =
  new Set([
    "local-dev",
    "local-demo",
    "staging",
    "production",
  ]);

const VALID_AUTH_MODES =
  new Set([
    "local",
    "okta",
  ]);

let loadedRuntimeConfig = null;
let runtimeConfigRequest = null;

export function validateRuntimeConfig(
  config
) {
  if (
    config === null ||
    typeof config !== "object" ||
    Array.isArray(config)
  ) {
    throw new Error(
      "Runtime configuration must be an object"
    );
  }

  if (
    !VALID_ENVIRONMENTS.has(
      config.environment
    )
  ) {
    throw new Error(
      "environment must be one of: local-dev, local-demo, staging, production"
    );
  }

  if (config.apiBasePath !== "/api") {
    throw new Error(
      "apiBasePath must be /api"
    );
  }

  if (
    !VALID_AUTH_MODES.has(
      config.authMode
    )
  ) {
    throw new Error(
      "authMode must be one of: local, okta"
    );
  }

  if (
    (config.environment ===
      "staging" ||
      config.environment ===
        "production") &&
    config.authMode !== "okta"
  ) {
    throw new Error(
      "Remote environments require authMode=okta"
    );
  }

  if (config.authMode === "okta") {
    requireText(
      config.oktaIssuer,
      "oktaIssuer"
    );
    requireText(
      config.oktaClientId,
      "oktaClientId"
    );
    requireText(
      config.oktaRedirectUri,
      "oktaRedirectUri"
    );
  }

  if (config.authMode === "local") {
    requireText(
      config.localAuthSubject,
      "localAuthSubject"
    );
    requireText(
      config.localAuthEmail,
      "localAuthEmail"
    );
    requireText(
      config.localAuthName,
      "localAuthName"
    );
  }

  requireText(
    config.googleMapsApiKey,
    "googleMapsApiKey"
  );
  requireText(
    config.googleMapsMapId,
    "googleMapsMapId"
  );
  requireText(
    config.applicationVersion,
    "applicationVersion"
  );
}

export function loadRuntimeConfig() {
  if (loadedRuntimeConfig !== null) {
    return Promise.resolve(
      loadedRuntimeConfig
    );
  }

  if (runtimeConfigRequest !== null) {
    return runtimeConfigRequest;
  }

  runtimeConfigRequest = fetch(
    RUNTIME_CONFIG_PATH,
    {
      cache: "no-store",
    }
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          "Failed to load runtime configuration: " +
            `HTTP ${response.status}`
        );
      }

      return response.json();
    })
    .then((config) => {
      validateRuntimeConfig(config);

      loadedRuntimeConfig =
        Object.freeze({
          ...config,
        });

      return loadedRuntimeConfig;
    })
    .catch((error) => {
      runtimeConfigRequest = null;
      throw error;
    });

  return runtimeConfigRequest;
}

export function getRuntimeConfig() {
  if (loadedRuntimeConfig === null) {
    throw new Error(
      "Runtime configuration has not been loaded"
    );
  }

  return loadedRuntimeConfig;
}

function requireText(
  value,
  fieldName
) {
  if (
    typeof value !== "string" ||
    value.trim().length === 0
  ) {
    throw new Error(
      `${fieldName} is required`
    );
  }
}
